<template>
  <div class="inside">
    <div class="title" v-html="title"></div>
    <div class="inside-in" v-html="page"></div>
  </div>
</template>

<script>
export default {
  name: 'inside',
  data () {
    return {
      title:'',
      page: ''
    }
  },
  created () {
    console.log("Arrivo al Inside.vue con page  "+this.$route.params.page)
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      this.loading = true      
      var parent = this
      this.axios.get('page/'+this.$route.params.page+'.html',{responseType: 'document',headers: { 
        "Content-Type": "application/x-www-form-urlencoded"
      }})
        .then(function (response) {
            parent.title = response.request.response.body.children.item(0).innerHTML
            parent.page = response.request.response.body.children.item(1).innerHTML
        })
        .catch(function (error) {
            console.log(error)
          parent.$route.push('/inside/error/not-find')
        })

     
    }
  }
}
</script>


<style scoped>
.inside .title{
    font-size: 2.2rem;
    margin:20px 0 30px 0;
}
</style>



// WEBPACK FOOTER //
// _Inside.vue?049ca5bc